function form() {
	document.querySelectorAll('.gform_wrapper').forEach(wrapper => {
		const grandParent = wrapper.parentElement?.parentElement;
		if (grandParent) {
			grandParent.classList.add('formBackground');
		}
	});

	const textField = document.querySelector('.standortSearch input:not([type="hidden"])');
	const selectField = document.querySelector('.standortResult select');

	const dynamicField = document.querySelector('.dynamicDefaultText textarea');
	if (dynamicField) {
		const urlParams = new URLSearchParams(window.location.search);
		let prod = urlParams.get('prod');
		let cat = urlParams.get('cat');

		const capitalize = str =>
			str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

		if (prod && cat) {
			prod = capitalize(prod);
			cat = capitalize(cat);

			dynamicField.value = `Ich interessiere mich für ${prod} im Bereich ${cat}.`;
		}
	}

	if (!textField || !selectField) {
		return;
	}

	function selectLocationBasedOnInput() {
		const inputValue = textField.value.trim();
		const selectOptions = Array.from(selectField.options);

		let matchedValue = '';

		const exactMatchOption = selectOptions.find(option => option.value === inputValue);
		if (exactMatchOption) {
			matchedValue = exactMatchOption.value;
		}
		else if (/^\d{5}$/.test(inputValue)) {
			const gerOption = selectOptions.find(option => option.value === 'ger');
			if (gerOption) {
				matchedValue = gerOption.value;
			}
		}
		else {
			for (const option of selectOptions) {
				const starPatternMatch = option.value.match(/^(\d)\*{3}$/);
				if (starPatternMatch && inputValue.startsWith(starPatternMatch[1])) {
					matchedValue = option.value;
					break;
				}
			}
		}

		if (selectField.value !== matchedValue) {
			selectField.value = matchedValue;
			selectField.dispatchEvent(new Event('change'));
		}
	}

	textField.addEventListener('input', selectLocationBasedOnInput);
}

export {
	form
};
